// import React from 'react';
// import { Link } from 'react-router-dom';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faMapMarkerAlt, faPhone, faEnvelope, faAnglesRight, faUser, faLocationDot } from '@fortawesome/free-solid-svg-icons';
// import './Footer.css';

// // Import logo images from assets
// import InstaImg from '../assets/SocialSvg/instagramImg.svg';
// import facebookImg from '../assets/SocialSvg/facebookImg.svg';
// import XImg from '../assets/SocialSvg/XImg.svg';
// import LinkendinImag from '../assets/SocialSvg/linkedin-original.svg'
// import YoutubeImg from '../assets/SocialSvg/youtube.svg'
// import { faFacebook, faInstagramSquare, faTelegram, faTwitterSquare } from '@fortawesome/free-brands-svg-icons';

// const Footer = () => {
//   return (
//     <footer className="footer-container">
//       {/* First div with logos and content */}
//       {/* Uncomment if needed
//       <div className="footer-logo-content">
//         <div className="footer-logos">
//           <Link to="/"><img src={logo1} alt="Logo 1" className="logo" id='img-logo' /></Link>
//           <Link to="/"><img src={logo3} alt="Logo 2" className="logo" id='img-logo' /></Link>
//         </div>
//         <p>THE ASSOCIATED CHAMBERS OF COMMERCE & INDUSTRY OF INDIA</p>
//       </div>
//       */}
//        <div className="footer-address">
//           <h4>ASSOCHAM Headquarters</h4>
//           <div className="address-div-footer">
          
//           <div className="icon-div-footer">

//             <div className="icon-footer-address">
//           <FontAwesomeIcon icon={faLocationDot} className='contact-icon' />
//           </div>

//           <div className="address-line">
//           <ul className='address-line-ul'>
//           <li> 4th Floor, YMCA Cultural Centre and Library Building,  </li>
          
//           <li>01, Jai Singh Road, New Delhi - 110001</li>
//           </ul>
//           </div>

// </div>
           
//            </div>
//           <div className="social-icons">
//             <div className="icon-circle"><img src={InstaImg} alt=" Instagram" /></div>
//             <div className="icon-circle"><img src={facebookImg} alt="Face Book" /> </div>
//             <div className="icon-circle"><img src={XImg} alt="Twitter" /> </div>
//             <div className="icon-circle"><img src={LinkendinImag} alt="Linked In" /> </div>
//             <div className="icon-circle"><img src={YoutubeImg} alt="Youtube" style={{height: '25px'}} /> </div>

//           </div>
//           </div>

// <div className="footer-quick-links">
//         <h4>Quick Links</h4>
//         <div className="footer-quick-link-div" id='footer-quick-link-div'>
//         <ul className='quick-link'>
//           <Link to='/about'>
//           <li> <FontAwesomeIcon icon={faAnglesRight} /> About ASSOCHAM</li></Link>
//           {/* <li> <FontAwesomeIcon icon={faAnglesRight} /> About GEM Rating</li> */}
//           <Link to='/gem-rating'>
//           <li> <FontAwesomeIcon icon={faAnglesRight} /> GEM Rating Systems  </li></Link>
//           </ul>
//           <ul className='quick-link'>
//             <Link to='/register'>
//           <li> <FontAwesomeIcon icon={faAnglesRight} /> Project/Product Registration</li></Link>
//           {/* <Link to='/faq'><li> <FontAwesomeIcon icon={faAnglesRight} /> Faq</li></Link> */}
//           <Link to='/paymentPage'>
//           <li> <FontAwesomeIcon icon={faAnglesRight} /> Payment</li>
//           </Link>
//         </ul>
//         </div>
//       </div>



//       {/* Third div with Contact Us */}
//       <div className="footer-contact">
//         <h4>Contact Us</h4>
//         <div className="contact-list-div">
//           <div className="contact-list">
//             <ul className='footerAddress'>
//               <li>
//                 <FontAwesomeIcon icon={faUser} style={{ color: "#8aaf3b" }} className="contact-icon" />
//                 <p> Amit Kumar Sharma</p>
//               </li>
//               <li>
//                 <FontAwesomeIcon icon={faPhone} className="contact-icon" />
//                 <a href="tel:+919352713762"><p> +91 9352713762</p></a>
//               </li>
//               <li>
//                 <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
//                 <a href="mailto:amitkumar.sharma@assocham.com"><p>amitkumar.sharma@assocham.com</p></a>
//               </li>
//             </ul>
//           </div>
//           <div className="contact-list-2">
//             <ul className='footerAddress'>
//               <li>
//                 <FontAwesomeIcon icon={faUser} className="contact-icon" />
//                 <p> Rohit Bhasin</p>
//               </li>
//               <li>
//                 <FontAwesomeIcon icon={faPhone} className="contact-icon" />
//                 <a href="tel:+917838701858"><p> +91 78387 01858</p></a>
//               </li>
//               <li>
//                 <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
//                 <a href="mailto:tarun.sachdeva@assocham.com"><p>rohit.bhasin@assocham.com</p></a>
//               </li>
//             </ul>
//             {/* <div className="footer-quick-links">
//               <FAQ />
//               </div> */}
//           </div>
//         </div>
//       </div>

//       {/* Second div with Quick Links */}
      
//     </footer>
//   );
// };

// export default Footer;




// new new code 




import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope, faAnglesRight, faUser, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import './Footer1.css';

// Import logo images from assets
import InstaImg from '../assets/SocialSvg/instagramImg.svg';
import facebookImg from '../assets/SocialSvg/facebookImg.svg';
import XImg from '../assets/SocialSvg/XImg.svg';
import LinkendinImag from '../assets/SocialSvg/linkedin-original.svg';
import YoutubeImg from '../assets/SocialSvg/youtube.svg';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-address">
        <h4>ASSOCHAM Headquarters</h4>
        <div className="address-div-footer">
          <div className="icon-div-footer">
            <div className="icon-footer-address">
              <FontAwesomeIcon icon={faLocationDot} className='contact-icon' />
            </div>
            <div className="address-line">
              <ul className='address-line-ul'>
                <li>4th Floor, YMCA Cultural Centre and Library Building,</li>
                <li>01, Jai Singh Road, New Delhi - 110001</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="social-icons">
          <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="icon-circle">
            <img src={InstaImg} alt="Instagram" />
          </a>
          <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="icon-circle">
            <img src={facebookImg} alt="Facebook" />
          </a>
          <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" className="icon-circle">
            <img src={XImg} alt="Twitter" />
          </a>
          <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="icon-circle">
            <img src={LinkendinImag} alt="LinkedIn" />
          </a>
          <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer" className="icon-circle">
            <img src={YoutubeImg} alt="Youtube" />
          </a>
        </div>
      </div>

      <div className="footer-quick-links">
        <h4>Quick Links</h4>
        <div className="footer-quick-link-div" id='footer-quick-link-div'>
          <ul className='quick-link'>
            <Link to='/about'>
              <li><FontAwesomeIcon icon={faAnglesRight} /> About ASSOCHAM</li>
            </Link>
            <Link to='/gem-rating'>
              <li><FontAwesomeIcon icon={faAnglesRight} /> GEM Rating Systems</li>
            </Link>
          </ul>
          <ul className='quick-link'>
            <Link to='/register'>
              <li><FontAwesomeIcon icon={faAnglesRight} /> Project/Product Registration</li>
            </Link>
            <Link to='/paymentPage'>
              <li><FontAwesomeIcon icon={faAnglesRight} /> Payment</li>
            </Link>
          </ul>
        </div>
      </div>

      <div className="footer-contact">
        <h4>Contact Us</h4>
        <div className="contact-list-div">
          <div className="contact-list">
            <ul className='footerAddress'>
              <li>
                <FontAwesomeIcon icon={faUser} style={{ color: "#8aaf3b" }} className="contact-icon" />
                <p>Amit Kumar Sharma</p>
              </li>
              <li>
                <FontAwesomeIcon icon={faPhone} className="contact-icon" />
                <a href="tel:+919352713762"><p>+91 9352713762</p></a>
              </li>
              <li>
                <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
                <a href="mailto:amitkumar.sharma@assocham.com"><p>amitkumar.sharma@assocham.com</p></a>
              </li>
            </ul>
          </div>
          <div className="contact-list-2">
            <ul className='footerAddress'>
              <li>
                <FontAwesomeIcon icon={faUser} className="contact-icon" />
                <p>Rohit Bhasin</p>
              </li>
              <li>
                <FontAwesomeIcon icon={faPhone} className="contact-icon" />
                <a href="tel:+917838701858"><p>+91 78387 01858</p></a>
              </li>
              <li>
                <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
                <a href="mailto:rohit.bhasin@assocham.com"><p>rohit.bhasin@assocham.com</p></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;